import * as React from 'react';
import styled from 'styled-components';
import { Block, Icon } from '../../../../components';
import LightBox from '../../../../components/LightBox';
import closeIcon from '../../../../../assets/icons/icon-close-red.svg';

interface ModalConfirmationProps {
  show: boolean;
  handleClose?: () => void;
}

export const CloseButton = styled.button.attrs((props: any) => ({
  padding: props.padding
}))`
  display: flex;
  align-items: center;
  padding: 0px 12px 0px 8px;
  padding: ${(props) => (props.padding ? props.padding : 'none')};
  border-radius: 4px;
  &:hover {
    background-color: #fed4d6;
  }
  &:focus,
  &:active {
    background-color: #fdadb3;
  }
`;
const ModalConfirmation: React.FC<ModalConfirmationProps> = (props) => {
  const { show, handleClose, children } = props;
  return (
    <LightBox IsModalOpen={show} autoCloseLayer>
      <Block
        width="100%"
        customized
        flexDirection="row"
        justifyContent="flex-end"
        padding="8px 4px 0px"
        data-testid="cmp-modal-confirmation"
      >
        {/* <InteractiveButton
          bkgColorEnabled="none"
          bkgColorHover="#FED4D6"
          bkgColorFocus="#FDADB3"
          bkgColorPressed="#FDADB3"
          borderRadius="4px"
          customized
          onClick={handleClose}
        >
          <Icon
            customized
            minWidth="40px"
            height="40px"
            alignItems="center"
            justifyContent="center"
          >
            <img src={closeIcon} alt="other" />
          </Icon>
        </InteractiveButton> */}
        {handleClose && (
          <CloseButton
            type="button"
            data-testid="cmp-close-LightBox"
            onClick={handleClose}
            padding="0px"
          >
            <Icon
              customized
              minWidth="40px"
              height="40px"
              alignItems="center"
              justifyContent="center"
            >
              <img src={closeIcon} alt="other" />
            </Icon>
          </CloseButton>
        )}
      </Block>
      {children}
    </LightBox>
  );
};
export default ModalConfirmation;
